import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult, useQueryClient } from 'react-query';
import { ErrorMessage } from 'types';
import { client } from 'utils/api-client';

export default function useDeleteOtherWorkType(): UseMutationResult<
  AxiosResponse<null>,
  AxiosError<ErrorMessage>,
  string
> {
  const queryClient = useQueryClient();

  const deleteOtherWorkType = (otherWorkTypeId: string): Promise<AxiosResponse<null>> => {
    return client.delete(`other-work-types/${otherWorkTypeId}/`);
  };

  return useMutation(deleteOtherWorkType, {
    onSuccess: () => {
      queryClient.removeQueries({
        queryKey: ['otherWorkTypes'],
      });
      queryClient.invalidateQueries({
        queryKey: ['otherWorkPayRateLookups'],
      });
    },
  });
}
